<template>
	<div class="c-splitpay" id="splitpay" :class="{ disabled: !active }">
		<div class="item" v-if="show('DKK')">
			<div
				align="center"
				class="viabill-pricetag"
				data-dynamic-price=".ccf-price-splitpay-tag"
				data-view="product"
				data-currency="dkk"
				data-dynamic-price-triggers="button.cco-productVariants__variant"
			></div>
		</div>
		<div class="item" v-if="show('DKK')">
			<anyday-price-widget
				class="anyday-pricetag"
				size="small"
				theme="light"
				orientation="logo-right"
				currency="DKK"
				price-selector=".ccf-price-splitpay-tag"
				price-format-locale="da-DK"
				locale="da-DK"
				shop-name="Surisuri ApS"
				token="83c1a4e4af7543158401317fd0182125"
				fully-clickable="true"
				container-breakpoint="100"
				debug="info"
			>
			</anyday-price-widget>
		</div>
		<div class="item" v-if="show('SEK')">
			<klarna-placement
				data-key="credit-promotion-auto-size"
				data-locale="sv-SE"
				:data-purchase-amount="price.priceAsFloat"
			></klarna-placement>
		</div>
	</div>
</template>

<script>
export default {
	name: "Splitpay",
	components: {},
	data: () => {
		return {
			current: 0,
			items: [],
		};
	},
	props: {
		active: Boolean,
		price: Object,
		currency: String,
	},

	methods: {
		index(value) {
			if (this.items.length === 1) {
				return true;
			}

			return this.current === value ? true : false;
		},
		show(currency) {
			return currency === this.currency ? true : false;
		},
		rotate() {
			this.items.forEach((item, i) => {
				item.classList.remove("enabled");
			});

			if (this.items[this.current]) {
				this.items[this.current].classList.add("enabled");
			}

			this.current++;
			if (this.current >= this.items.length) {
				this.current = 0;
			}
		},
	},

	mounted() {
		this.items = [...document.querySelectorAll("#splitpay .item")];

		if (this.items.length === 1) {
			this.items[0].classList.add("enabled");
			return;
		}

		this.rotate();

		setInterval(() => {
			this.rotate();
		}, 4000);
	},
};
</script>

<style lang="scss">
@import "@backend/scss/abstracts/variables.scss";
@import "@backend/scss/abstracts/mixins.scss";

.c-splitpay {
	position: relative;
	background-color: #fbf5f6;
	height: 42px;
	display: flex;
	align-items: center;
	justify-content: center;

	&.disabled {
		display: none;
	}

	.item {
		position: absolute;

		transition: $t-hover;
		opacity: 1;

		.viabill {
			width: unset !important;
			max-width: 200px !important;
		}

		opacity: 0;
		pointer-events: none;

		&.enabled {
			opacity: 1;
			pointer-events: all;
		}
	}
}
</style>
